// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Gift = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M9 14.5S2.5 11 2.5 6.875A3.375 3.375 0 0 1 5.875 3.5c1.412 0 2.621.77 3.125 2 .504-1.23 1.713-2 3.125-2A3.375 3.375 0 0 1 15.5 6.875C15.5 11 9 14.5 9 14.5Z"
    />
  </svg>
);
const ForwardRef = forwardRef(Gift);
export default ForwardRef;
